// File: cgp-check-all.component.ts
// Author: Joseph M Diaz
// Date: 6/12/2018
// Desc: CGP Check All Component.
// Other Contributors:

import { Component, Input } from '@angular/core';

@Component({
    selector: 'cgp-check-all',
    templateUrl: './cgp-check-all.template.html',
    styleUrls: ['./cgp-check-all.style.scss']
})
export class CgpCheckAllComponent {
    private raised = false; // pagination === 'raised'
    private checkState = 'none';

    @Input() pagination: any = true;
    @Input() disabled = false;
    @Input() onSelectPage: Function;
    @Input() onSelectAllPages: Function;
    @Input() onDeselectPage: Function;
    @Input() onDeselectAllPages: Function;

    checkStates = {
        none: 'none',
        partial: 'partial',
        all: 'all'
    };

    isRaised() {
        return this.raised;
    }

    checkIcon = function() {
        if (this.checkState === this.checkStates.none) {
            return'fa-square-o';
        } else if (this.checkState === this.checkStates.partial) {
            return 'fa-minus-square-o';
        } else { // all
            return 'fa-check-square-o';
        }
    };

    ngOnInit() {
        if (this.pagination) {
            if (this.pagination.type && this.pagination.type === 'raised') {
                this.raised = true;
            }
            this.pagination = true;
        } else {
            this.pagination = false;
        }
    }

    ngOnDestroy() {
        this.onSelectPage = null;
        this.onSelectAllPages = null;
        this.onDeselectPage = null;
        this.onDeselectAllPages = null;
        this.checkIcon = null;
        this.setCheckState = null;
        this.getCheckState = null;
    }

    setCheckState = function(checkState) {
        this.checkState = checkState;
    };

    getCheckState = function () {
        return this.checkState;
    };

    onCheckClick() {
        if (this.checkState === this.checkStates.none) {
            this.selectPage();
        } else { // partial / all
            this.deselectPage();
        }
    }

    selectPage() {
        this.checkState = this.checkStates.all;

        if (this.pagination) {
            if (this.onSelectPage) {
                this.onSelectPage();
            }
        } else {
            if (this.onSelectAllPages) {
                this.onSelectAllPages();
            }
        }
    }

    selectAllPages() {
        this.checkState = this.checkStates.all;

        if (this.onSelectAllPages) {
            this.onSelectAllPages();
        }
    }

    deselectPage() {
        this.checkState = this.checkStates.none;

        if (this.pagination) {
            if (this.onDeselectPage) {
                this.onDeselectPage();
            }
        } else {
            if (this.onDeselectAllPages) {
                this.onDeselectAllPages();
            }
        }
    }

    deselectAllPages() {
        this.checkState = this.checkStates.none;

        if (this.onDeselectAllPages) {
            this.onDeselectAllPages();
        }
    }
}
